import { pushToStoreArray, Store } from '@sama/app-state';
import { matches } from '@sama/micro-dash';
import { ShapeGroupOrderState } from '../../team-apis/content/content-connector';
import {
  PointCloudOrthographicShapeType,
  pointCloudOrthographicShapeTypes,
} from '../../team-apis/otterdam/answers/point-cloud-answer';
import {
  PointType,
  ShapeType,
} from '../../team-apis/otterdam/answers/shape-typings';
import {
  OrthographicShapeState3D,
  ShapeState,
} from '../annotation/shared/state/shape-state';

export function addUngroupedShape<
  P extends PointType,
  T extends ShapeType,
  S extends ShapeState<P, T>,
>(shape: S, shapeGroupOrderStore: Store<ShapeGroupOrderState>) {
  shapeGroupOrderStore.getRootStore().batch(() => {
    if (
      shapeGroupOrderStore
        .state()
        .shapeAndGroupOrder.some(matches({ index: shape.index, type: 'shape' }))
    ) {
      throw new Error(`Shape ${shape.index} already exists`);
    }
    shapeGroupOrderStore('shapes')(shape.index).set(shape);
    pushToStoreArray(shapeGroupOrderStore('shapeAndGroupOrder'), {
      type: 'shape',
      index: shape.index,
    });
  });
}

export function isOrthographicShape3D(
  state: ShapeState,
): state is OrthographicShapeState3D {
  return pointCloudOrthographicShapeTypes.includes(
    state.type as PointCloudOrthographicShapeType,
  );
}
